<template>
  <CouponDetails />
</template>

<script>
import CouponDetails from "@/components/MasterSetup/Coupon/CouponDetails";

export default {
  name: "Coupon",
  components: {
    CouponDetails
  }
};
</script>